class TipoDocumentoEnum {
  constructor() {
    this.OUTROS = 0;
    this.CTE = 1;
    this.MDFE = 2;
    this.CFE = 3;
    this.CONTRATO_DE_TRANSPORTE = 4;
    this.TERMO_DE_ESTADIA = 5;
    this.ORDEM_CARREGAMENTO = 6;
    this.CARTA_CORRECAO = 7;
    this.TICKET_PESAGEM = 8;
    this.CHECKLIST = 9;
    this.LAUDO_CLASSIFICACAO = 10;
    this.NFE = 11;
  }

  getTiposLabel() {
    return [
      { label: 'Outros', value: this.OUTROS },
      { label: 'CT-e', value: this.CTE },
      { label: 'MDF-e', value: this.MDFE },
      { label: 'Carta Frete Eletrônico', value: this.CFE },
      { label: 'Contrato de Transporte', value: this.CONTRATO_DE_TRANSPORTE },
      { label: 'Termo de Estadia', value: this.TERMO_DE_ESTADIA },
      { label: 'Ordem de Carregamento', value: this.ORDEM_CARREGAMENTO },
      { label: 'Carta de Correção', value: this.CARTA_CORRECAO },
      { label: 'Ticket de Pesagem', value: this.TICKET_PESAGEM },
      { label: 'Checklist', value: this.CHECKLIST },
      { label: 'Laudo de Classificação', value: this.LAUDO_CLASSIFICACAO },
      { label: 'Nota Fiscal Eletrônica', value: this.NFE },
    ];
  }

  getTipo(tipoDocumento) {
    return this.getTiposLabel()
      .filter(label => label.value === tipoDocumento)
      .shift();
  }
}

export default new TipoDocumentoEnum();
